<template>
  <section class="flex flex-col gap-4 w-full">
    <div
      class="w-full flex justify-between gap-4 bg-white p-6 my-3 rounded-md shadow-md"
    >
      <p class="font-[800] w-[90%] text-neutral-900">
        {{ questionCount }}.{{ " " + question?.prompt }}
      </p>

      <MessageVoice
        v-if="playAudio"
        :msg="msgVoice(question.prompt)"
        :scaleIcons="0.8"
        :showIconsName="false"
        @onEndMessage="onSpeak($event)"
      />
    </div>
    <div class="w-full">
      <div
        v-for="(item, i) in question?.items"
        :key="i"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion((i + 1) * 200)"
        :class="`bg-white flex items-center pl-3 my-3 gap-2 rounded-md shadow-md w-full`"
      >
        <RadioButton
          :inputId="item.id"
          name="answer"
          :value="item"
          :disabled="answers.isDisabled"
          v-model="answers.selected"
          @click.prevent="chooseItem(letter)"
        />
        <label :for="item.id" class="cursor-pointer p-4 w-full">
          <p>
            <b>{{ String.fromCharCode(i + 65) }}.</b> {{ item.answerText }}
          </p>
        </label>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { defineComponent } from "vue";

export default defineComponent({
  name: "questionComponent",
  emits: ["onSpeak"],
  props: {
    question: {
      required: true,
      type: Object,
    },
    answers: {
      required: true,
      type: Object,
    },
    questionCount: {
      required: true,
      type: Number,
    },
    letter: {
      type: String,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    question: {
      handler: function (val, oldVal) {
        this.playAudio = false;
        setTimeout(() => {
          this.playAudio = true;
        }, 200);
      },
      deep: true,
    },
    letter(val) {
      this.chooseItem(val);
    },
  },
  data() {
    return {
      playAudio: true as boolean,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
    };
  },
  methods: {
    msgVoice(prompt: string): string {
      let result = prompt;
      let alphabetIndex = 0;

      this.question?.items.forEach((element) => {
        const letter = String.fromCharCode(65 + alphabetIndex);
        result += ". item " + letter + "... " + element.answerText;
        alphabetIndex++;
      });
      return result;
    },
    onSpeak(event: any): void {
      this.$emit("onSpeak", event);
    },
    chooseItem(letter: any): void {
      if (String.fromCharCode(0 + 65) === letter ?? "A") {
        this.answers.selected = this.question?.items[0];
      } else if (String.fromCharCode(1 + 65) === letter ?? "B") {
        this.answers.selected = this.question?.items[1];
      } else if (String.fromCharCode(2 + 65) === letter ?? "C") {
        this.answers.selected = this.question?.items[2];
      } else if (String.fromCharCode(3 + 65) === letter ?? "D") {
        this.answers.selected = this.question?.items[3];
      }
    },
  },
});
</script>
